import SubTitle from '@/pages/WgqAllMaps/components/SubTitle';
import { keepZeroOrLine } from '@/utils/utils';
import { apiV2WaterMapDataSevenDaysAlertPost } from '@maxtropy/device-customer-apis-v2';
import { useRequest } from 'ahooks';
import dayjs from 'dayjs';
import { useContext } from 'react';
import { ShareConfigDataWaterContext } from '../../../..';
import styles from './index.module.scss';

const UnrestoredAlarm = () => {
  const { configDetail } = useContext(ShareConfigDataWaterContext);

  const { data: alarmData } = useRequest(() => apiV2WaterMapDataSevenDaysAlertPost({}));

  const handleClick = () => {
    window.open(
      `/device/alarm/record?startTime=${dayjs().subtract(6, 'day').startOf('day').valueOf()}&endTime=${dayjs()
        .endOf('day')
        .valueOf()}&labelIds=${configDetail?.labelIds}`,
      '_blank'
    );
  };

  return (
    <SubTitle title="近七日未恢复报警">
      <div className={styles.alarmBox} onClick={handleClick}>
        <div className={`${styles.alarmItem} ${styles.highest}`}>
          <div className={styles.num}>{keepZeroOrLine(alarmData?.highestLevelCount)}</div>
          <div className={styles.text}>最高级</div>
        </div>
        <div className={`${styles.alarmItem} ${styles.high}`}>
          <div className={styles.num}>{keepZeroOrLine(alarmData?.highLevelCount)}</div>
          <div className={styles.text}>高级</div>
        </div>
        <div className={`${styles.alarmItem} ${styles.middle}`}>
          <div className={styles.num}>{keepZeroOrLine(alarmData?.mediumLevelCount)}</div>
          <div className={styles.text}>中级</div>
        </div>
        <div className={`${styles.alarmItem} ${styles.low}`}>
          <div className={styles.num}>{keepZeroOrLine(alarmData?.lowLevelCount)}</div>
          <div className={styles.text}>低级</div>
        </div>
        <div className={`${styles.alarmItem} ${styles.lowest}`}>
          <div className={styles.num}>{keepZeroOrLine(alarmData?.lowestLevelCount)}</div>
          <div className={styles.text}>最低级</div>
        </div>
      </div>
    </SubTitle>
  );
};

export default UnrestoredAlarm;
